"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchSettings = fetchSettings;
exports.saveSettings = saveSettings;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _immutable = _interopRequireDefault(require("immutable"));

function getUri(userId) {
  return "/gamera/v2/item/file-manager/user-settings-uid:" + userId;
}

function fetchSettings(userId) {
  var uri = getUri(userId);
  return _apiClient.default.get(uri).then(function (response) {
    return _immutable.default.fromJS(JSON.parse(response.value));
  }).catch(function () {
    return _immutable.default.Map();
  });
}

function saveSettings(userId, data) {
  var uri = getUri(userId);
  return _apiClient.default.put(uri, {
    data: data
  });
}